import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../theme/ThemeProvider';

/**
 * TRU wordmark for app chrome. Dark mode wraps the full logo on a light plate
 * so the navy wordmark in truLogo.png stays readable on dark nav bars.
 */
const TruLogo = ({
  width: _width = '80px',
  className: _className = ''
}) => {
  const {
    mode
  } = useTheme();
  if (mode === 'dark') {
    return /*#__PURE__*/React.createElement("span", {
      className: `tru-logo tru-logo--dark ${_className}`.trim()
    }, /*#__PURE__*/React.createElement("span", {
      className: "tru-logo__plate"
    }, /*#__PURE__*/React.createElement("img", {
      width: _width,
      className: "tru-logo__img",
      src: "/img/logos/truLogo.png",
      alt: "TRU Logo"
    })));
  }
  return /*#__PURE__*/React.createElement("img", {
    width: _width,
    className: _className,
    src: "/img/logos/truLogo.png",
    alt: "TRU Logo"
  });
};
TruLogo.propTypes = {
  width: PropTypes.string,
  className: PropTypes.string
};
export default TruLogo;